import { render, staticRenderFns } from "./PostComponent.vue?vue&type=template&id=29c5b8a2&scoped=true&"
import script from "./PostComponent.vue?vue&type=script&lang=js&"
export * from "./PostComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c5b8a2",
  null
  
)

export default component.exports